import { useEffect, useState } from "react";
import Navbar from "../../components/navbar/Navbar";
import { BiSolidHome } from "react-icons/bi";
import Footer from "../../components/footer/Footer";
import { useParams, Link } from "react-router-dom";
import ProductCard from "../../components/ProductCard/ProductCard";
// import { Swiper, SwiperSlide } from "swiper/react";
import { IoMdArrowRoundForward } from "react-icons/io";
import { RiWhatsappFill } from "react-icons/ri";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import "swiper/css";

const ProductDetails = () => {
  document.title = "ProductDetails";
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const [data, setData] = useState([]);
  // const [dataLength] = useState(4);

  const [activeTabDesktop, setActiveTabDesktop] = useState(0);
  const [activeTabMobile, setActiveTabMobile] = useState(0);

  const [dataLength, setDataLength] = useState(4);

  useEffect(() => {
    const updateDataLength = () => {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setDataLength(2);
      } else {
        setDataLength(4);
      }
    };

    updateDataLength();
    window.addEventListener("resize", updateDataLength);

    return () => window.removeEventListener("resize", updateDataLength);
  }, []);

  // Fetch main product details
  useEffect(() => {
    fetch(`https://backend-server-nine-opal.vercel.app/contents/${id}`, {
      // credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        setProduct(result);
        setMainImage(result.Product_Details_Photo);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    if (!product) return;

    fetch(
      `https://backend-server-nine-opal.vercel.app/contents?category=${product.product_Category}`,
      {
        // credentials: "include",
      },
    )
      .then((res) => res.json())
      .then((result) => {
        const filtered = result.filter((p) => p._id !== product._id);
        setData(filtered);
      })
      .catch((error) => {
        console.error("Error fetching similar products:", error);
      });
  }, [product]);

  if (loading) return <div className="loader">Loading...</div>;
  if (!product) return <div>No product found</div>;
  if (!product.richTexts || product.richTexts.length === 0) {
    return <p>No product details available.</p>;
  }

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // Filter out empty/null images
  const thumbnails = [
    product.Product_Details_Photo,
    product.photo1,
    product.photo2,
    product.photo3,
    product.photo4,
  ].filter(Boolean);

  return (
    <div id="ProductDetails">
      <Navbar />
      <div className="container md:px-2 lg:px-0 mx-auto py-20">
        {/* Breadcrumb */}
        <div className="text-sm breadcrumbs mb-4">
          <ul>
            <li>
              <Link
                to="/"
                onClick={scrollToTop}
                className="flex items-center gap-1 hover:text-[#1DA14D] hover:font-semibold"
              >
                <BiSolidHome className="text-lg" />
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/products"
                onClick={scrollToTop}
                className="flex items-center hover:text-[#1DA14D] hover:font-semibold gap-1"
              >
                Product
              </Link>
            </li>
            <li>Our product list</li>
          </ul>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left - Images */}
          <div className="flex flex-col-reverse md:flex-row gap-4">
            {/* Thumbnails */}
            <div className="flex flex-row justify-between md:flex-col rounded-md gap-3">
              {thumbnails.map((photo, index) => (
                <img
                  key={index}
                  loading="lazy"
                  src={photo}
                  alt={`Thumbnail ${index}`}
                  className={`w-20 h-20 object-cover border bg-white rounded-md cursor-pointer ${
                    mainImage === photo ? "border-black" : ""
                  }`}
                  onClick={() => setMainImage(photo)}
                />
              ))}
            </div>

            {/* Main image */}
            {/* <div className="flex-1">
              <img
                src={mainImage}
                alt={product.Product_name}
                className="w-full h-[500px] object-contain rounded bg-white"
              />
            </div> */}
            <div className="flex-1 bg-white rounded">
              <Zoom>
                <img
                  loading="lazy"
                  src={mainImage}
                  alt={product.Product_name}
                  className="w-full h-[500px] object-contain rounded bg-white"
                />
              </Zoom>
            </div>
          </div>

          {/* Right - Info */}
          <div className="text-left">
            <h1 className="text-2xl font-semibold mb-3">
              {product.Product_name}
            </h1>
            <p className="mb-2">
              <strong>Brand:</strong> {product.brand_Name?.replace(/_/g, " ")}
            </p>
            <p className="mb-2">
              <strong>Category:</strong> {product.product_Category}
            </p>
            <p className="mb-2">
              <strong>Pack Size:</strong> {product.Pack_Size}
            </p>
            <p className="mb-2">
              <strong>Net Weight:</strong> {product.Net_Wt}
            </p>
            <p className="mb-2">
              <strong>Gross Weight:</strong> {product.Gross_Wt}
            </p>
            <p className="mb-4">
              <strong>Carton Dimension:</strong> {product.Carton_Dim}
            </p>
            <div className="mt-6 lg:w-9/12 rounded-2xl border sticky top-0 ">
              <div className="mx-auto p-4 space-y-4">
                <p className="text-base font-semibold text-gray-600 pb-4">
                  Buy Our Product
                </p>
                <Link
                  to="https://masalabazaarbd.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn w-full font-semibold bg-[#e7c873] hover:border-[#1C3A27] hover:bg-[#ffe0a6] hover:text-[#1C3A27] text-white hover:border-2 hover:bg-[#e7c87300]">
                    Buy From Masala Bazaar{" "}
                    <IoMdArrowRoundForward className="text-2xl" />
                  </button>
                </Link>
                <button className="btn w-full font-semibold bg-[#2a974b] text-white hover:border-[#2a974b] hover:border-2 hover:bg-[#1C3A27]">
                  Contact with Whatsapp <RiWhatsappFill className="text-2xl" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs / Accordion */}
        <div className="mt-8">
          {/* Desktop Tabs */}
          <div className="hidden md:flex border-b rounded-t-lg h-full  gap-2 pb-2">
            {product.richTexts.map((section, index) => (
              <button
                key={index}
                onClick={() => setActiveTabDesktop(index)}
                className={`relative flex justify-center items-center rounded-t-lg px-6 py-2 text-center font-bold transition-colors duration-200 
        ${
          activeTabDesktop === index
            ? "bg-[#1C3A27] text-white"
            : "bg-[#ffe0a6] text-gray-700"
        } hover:bg-[#1DA14D] hover:text-white`}
              >
                {section.title}

                {/* Arrow indicator when active */}
                {activeTabDesktop === index && (
                  <span
                    className="absolute -bottom-[9px] left-1/2 -translate-x-1/2 w-0 h-0 
          border-l-[10px] border-r-[10px] border-t-[10px] border-l-transparent border-r-transparent border-t-[#1C3A27]"
                  ></span>
                )}
              </button>
            ))}
          </div>

          {/* Desktop Content */}
          {product.richTexts[activeTabDesktop] && (
            <div className="hidden md:block p-4 min-h-96 text-left border rounded-b-md prose max-w-none">
              <div
                dangerouslySetInnerHTML={{
                  __html: product.richTexts[activeTabDesktop].content,
                }}
              />
            </div>
          )}

          {/* Mobile Accordion */}
          <div className="md:hidden space-y-2">
            {product.richTexts.map((section, index) => (
              <div key={index} className="border rounded-lg">
                <button
                  onClick={() =>
                    setActiveTabMobile(activeTabMobile === index ? null : index)
                  }
                  className="w-full flex justify-between rounded-lg items-center px-4 py-2 bg-[#ffe0a6] text-left font-semibold text-gray-700 hover:text-white hover:bg-[#1C3A27]"
                >
                  {section.title}
                  <span>{activeTabMobile === index ? "−" : "+"}</span>
                </button>

                {activeTabMobile === index && (
                  <div className="p-4 text-left prose max-w-none border-t">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: section.content,
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Similar Products */}
        <div className="py-10 p-4">
          <h1 className="lg:text-2xl mb-4 font-semibold text-left underline">
            See More Similar Products
          </h1>
          {/* <Swiper
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1440: { slidesPerView: 4 },
            }}
          >
            {data.slice(0, dataLength).map((prod) => (
              <SwiperSlide key={prod._id}>
                <ProductCard product={prod} />
              </SwiperSlide>
            ))}
          </Swiper> */}
          <div className="grid grid-cols-1 md:grid-cols-2 [@media(min-width:1440px)]:grid-cols-4 xl:grid-cols-5 gap-4">
            {data.slice(0, dataLength).map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetails;
